import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { rootReducer, type RootState } from './root-reducer';
import { rootSaga } from './root-saga';

/**
 * Redux Toolkit + redux-saga (RTK Query KULLANILMAZ — CLAUDE.md).
 * Depolar `createEntityAdapter` ile normalizedir; önbellek ve invalidation
 * elle yönetilir. Kök sıfırlama `root-reducer.ts` içindedir.
 */
export function makeStore(preloadedState?: Partial<RootState>) {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    /*
     * KISMİ ÖN YÜK: `combineReducers` verilmeyen dilimi kendi başlangıç
     * durumuyla doldurur. Tip tarafı tam durumu ister (kök sıfırlama sarmalı
     * `RootState` döndürür), o yüzden daraltma BURADA — tek yerde — yapılır;
     * testler yalnız ilgilendikleri dilimi kurar (`render-panel`).
     */
    preloadedState: preloadedState as RootState | undefined,
    middleware: (getDefault) => getDefault({ thunk: false }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });

  sagaMiddleware.run(rootSaga);
  return store;
}

export type AppStore = ReturnType<typeof makeStore>;
export type { RootState };
export type AppDispatch = AppStore['dispatch'];
